import * as React from 'react';

var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgNewCollection = function SvgNewCollection(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        "aria-hidden": "true"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.653 1.5a10.502 10.502 0 0 0-8.214 3.908.75.75 0 0 1-1.168-.942 12.002 12.002 0 0 1 18.74.073.75.75 0 1 1-1.174.932 10.502 10.502 0 0 0-8.184-3.97ZM3.22 7.514a.75.75 0 0 1 .838.457l1.554 3.885V8.25a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.446.279l-1.554-3.885v3.606a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 .608-.736ZM10.862 9a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h1.5a.75.75 0 0 1 0 1.5h-1.5a2.25 2.25 0 0 1-2.25-2.25v-4.5a2.25 2.25 0 0 1 2.25-2.25h1.5a.75.75 0 0 1 0 1.5h-1.5Z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.612 12.75a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM15.362 7.5a.75.75 0 0 1 .75.75v2.017c0 1.05.2 2.09.59 3.063l.042.104.897-3.14a.75.75 0 0 1 1.442 0l.898 3.141.042-.104c.39-.975.59-2.014.589-3.064V8.25a.75.75 0 0 1 1.5 0v2.017a9.75 9.75 0 0 1-.697 3.62l-.857 2.142a.75.75 0 0 1-1.417-.073l-.779-2.726-.779 2.726a.75.75 0 0 1-1.417.072l-.856-2.14a9.75 9.75 0 0 1-.698-3.62V8.25a.75.75 0 0 1 .75-.75ZM2.188 18.15a.75.75 0 0 1 1.05.15 10.476 10.476 0 0 0 16.759.022.75.75 0 1 1 1.198.902 11.976 11.976 0 0 1-19.158-.025.75.75 0 0 1 .15-1.05Z",
        clipRule: "evenodd"
    })));
};

export { SvgNewCollection as default };
//# sourceMappingURL=new-collection.svg.js.map
